import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import { Common } from "@root/components/common/CommonTypes";
import { Emitter } from "strict-event-emitter";

export type SelectOption = {value: string, text: string};

export default class Select extends ComponentBase implements Common.InputComponent
{
  emitter: Emitter<{ change: [value: string, isOk: boolean]; }>;
  _isOk: boolean = false;

  select: HTMLSelectElement;

  constructor(elem: ComponentElem)
  {
    super(elem);

    this.emitter = new Emitter();
    
    this.select =  this.$root[0] as HTMLSelectElement;
    this.select.selectedIndex = 0;

    this.$root.on("change", ()=>
    {
      this.update();
    });

    this.update();
  }

  setOptions(dataList: SelectOption[])
  {    
    let firstElem = this.$root.find("option")[0];
    this.$root.empty();
    if(firstElem.hasAttribute("placeholder")) this.$root.append(firstElem);

    dataList.forEach((data)=>
    {
      let $option = $(`<option value="${data.value}">${data.text}</option>`);
      this.$root.append($option);
    });
  }

  update()
  {
    this.$root.toggleClass("is-not-ok", !this.isOk());
    this.emitter.emit("change", this.getValue(), this.isOk());
  }

  getValue(): string
  {
    return this.select.value;
  }

  setValue(value: string)
  {
    let options = this.$root.find("option").toArray();
    options.forEach((elem: HTMLOptionElement, index)=>
    {
      if(elem.value === value)
      {
        this.select.selectedIndex = index;
        this.update();
      }
      
    });
    
  }

  isOk(): boolean
  {
    return this.select.selectedIndex > 0;
  }

  reset()
  {    
    this.select.selectedIndex = 0;
    this.update();
  }
}